/**
 * Remote Flash
 * This service allows users to flash a telematics device over the air (FOTA) and retrieve the reported firmware information. 
 *
 * OpenAPI spec version: 0.1.5
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * The status of the desired firmware that is flashed to the device. If there is no Firmware Status, default will be N/A. 
 */
export type Status = 'N/A' | 'Inactive' | 'Starting flash file extraction' | 'Starting signature verification' | 'Starting O/S flash' | 'Starting app flash' | 'Success' | 'Flash file corrupt' | 'Signature verification failed' | 'O/S flash failed' | 'App flash failed' | 'Hardware type mismatch' | 'Location code mismatch';

export const Status = {
    NA: 'N/A' as Status,
    Inactive: 'Inactive' as Status,
    StartingFlashFileExtraction: 'Starting flash file extraction' as Status,
    StartingSignatureVerification: 'Starting signature verification' as Status,
    StartingOSFlash: 'Starting O/S flash' as Status,
    StartingAppFlash: 'Starting app flash' as Status,
    Success: 'Success' as Status,
    FlashFileCorrupt: 'Flash file corrupt' as Status,
    SignatureVerificationFailed: 'Signature verification failed' as Status,
    OSFlashFailed: 'O/S flash failed' as Status,
    AppFlashFailed: 'App flash failed' as Status,
    HardwareTypeMismatch: 'Hardware type mismatch' as Status,
    LocationCodeMismatch: 'Location code mismatch' as Status
};